module.exports = __webpack_public_path__ + "img/CM-SL-CA-Nissan-Playful.2644a1a8.jpeg";